import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import CommentDataAttrDiv from '../../../../lego/CommentDataAttrDiv';
import s from './RootLayout.scss';
var RootLayout = function (_a) {
    var className = _a.className, contentBlocks = _a.contentBlocks, prefix = _a.prefix, rest = __rest(_a, ["className", "contentBlocks", "prefix"]);
    return (React.createElement(CommentDataAttrDiv, __assign({ className: c(s['root'], className) }, rest),
        prefix,
        React.createElement("div", { className: s['content'] }, contentBlocks)));
};
RootLayout.displayName = 'RootLayout';
export default RootLayout;
//# sourceMappingURL=RootLayout.js.map